import getEnv from '../env'

// in production, log error on server only
// log on client & server otherwise
const logError = ({
  source,
  url,
  message,
  code,
  httpStatus,
  env = getEnv(),
}) => {
  // TODO: do we want to log client-side errors at all?
  if (typeof window !== 'undefined' && env === 'production') return
  console.log(JSON.stringify({ // eslint-disable-line no-console
    source,
    url,
    message,
    code,
    httpStatus,
  }))
}

export default logError
